import { Helmet } from 'react-helmet-async';
// sections
import Login from '../../../sections/auth/intranet/Login';
// import Login from '../../sections/auth/LoginAuth0';

// ----------------------------------------------------------------------

export default function LoginPage() {
  return (
    <>
      <Helmet>
        <title> Accesso Intranet | Gestione mediazioni sanitarie Arca di Noè</title>
      </Helmet>

      <Login />
    </>
  );
}
